"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _formatError = _interopRequireDefault(require("./formatError"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = function _default(error, input) {
  if (!window.Sentry) {
    return;
  }
  if (error instanceof Error) {
    // Added to avoid a bug when running gatsby build.
    // 'WebpackError: ReferenceError: window is not defined'
    // https://www.gatsbyjs.org/docs/debugging-html-builds/
    if (typeof window !== 'undefined') {
      window.Sentry.captureException(error);
    }
  } else {
    var formattedError = (0, _formatError["default"])(error, input);
    // Added to avoid a bug when running gatsby build.
    // 'WebpackError: ReferenceError: window is not defined'
    // https://www.gatsbyjs.org/docs/debugging-html-builds/
    if (typeof window !== 'undefined') {
      window.Sentry.captureMessage(formattedError);
    }
  }
};
exports["default"] = _default;